import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')

export const state = {
      cached: {},
      tutorial: '',
      showTutorial: false,
    }

export const getters = {
      getTutorialUrl(state) {
        return state.tutorial
      },
      showTutorial(state) {
        return state.showTutorial
      },
    }

export const mutations = {
      SET_TUTORIAL_URL(state, payload) {
        state.tutorial = `${serverUrl}/media/videos/${payload}.mp4`
      },
      SET_SHOW_TUTORIAL(state, payload) {
        state.showTutorial = payload
      },
    }

export const actions = {
         init({ state, dispatch }) {},

         setTutorialUrl(state, payload) {
           state.commit('SET_TUTORIAL_URL', payload)
          },
          setShowTutorial(state, payload) {
           state.commit('SET_SHOW_TUTORIAL', payload)
         },
       }
